import { usePrivy } from '@privy-io/react-auth'
import { useMemo } from 'react'
import { WalletClient } from 'viem'
import { useWalletClient } from 'wagmi'

export function useAuthenticatedWalletClient(): WalletClient | undefined {
  const { data: walletClient } = useWalletClient()
  const { user } = usePrivy()
  const linkedWallets = user?.linkedAccounts.filter((account) => account.type === 'wallet')

  const authedWalletClient = useMemo(() => {
    return linkedWallets?.find((wallet) => wallet.address.toLowerCase() === walletClient?.account.address.toLowerCase())
      ? walletClient
      : undefined
  }, [linkedWallets, walletClient])

  return authedWalletClient
}
